import { AssetStoryblok } from './generated'
import { Image } from './types'

export type ResizeOptions = {
  width?: number
  height?: number
  smart?: boolean
}

const ASSET_CDN = 'https://img2.storyblok.com'

function getAssetURLParts(assetURL: string) {
  const pathname = assetURL.replace('https://a.storyblok.com/', '')
  const [prefix, spaceID, size, uniqueID, filename] = pathname.split('/')

  return {
    prefix,
    spaceID,
    size,
    uniqueID,
    filename,
    pathname,
  }
}

function calculateWidth(originalWidth: number, originalHeight: number, newHeight: number) {
  return Math.round((originalWidth / originalHeight) * newHeight)
}

function calculateHeight(originalWidth: number, originalHeight: number, newWidth: number): number {
  return Math.round((originalHeight / originalWidth) * newWidth)
}

/** Gibt `null` zurueck, wenn im Storyblok-Eintrag kein Bild hinterlegt ist. */
export function resizeImage(image: AssetStoryblok | null | undefined, options: ResizeOptions): Image | null {
  if (!image?.filename) {
    return null
  }

  const parts = getAssetURLParts(image.filename)
  const smart = options.smart ? '/smart' : ''
  const url = `${ASSET_CDN}/${options.width}x${options.height}${smart}/${parts.pathname}`

  // Calculate the new image sized and respect proportional resizing.
  const size = (parts.size || '').split('x')
  const originalWidth = parseInt(size[0])
  const originalHeight = parseInt(size[1])
  const knownSize = !isNaN(originalWidth) && !isNaN(originalHeight) && originalWidth > 0 && originalHeight > 0
  const requestedWidth = options.width || 0
  const requestedHeight = options.height || 0
  const width = requestedWidth || (knownSize ? calculateWidth(originalWidth, originalHeight, requestedHeight) : 0)
  const height = requestedHeight || (knownSize ? calculateHeight(originalWidth, originalHeight, requestedWidth) : 0)

  return {
    id: image.id,
    url,
    height,
    width,
    alt: image.alt,
    name: image.name,
    title: image.title,
    copyright: image.copyright,
    filename: url,
    orientation: width > height ? 'landscape' : height > width ? 'portrait' : 'square',
    mime: image.mime,
  }
}
